export const segmentVisibilities = {
  PRIVATE_VISIBLE: 'private_visible',
  ADMIN_VISIBLE: 'admin_visible',
  FIRM_VISIBLE: 'firm_visible',
} as const

export type SegmentVisibility =
  typeof segmentVisibilities[keyof typeof segmentVisibilities]

export type SegmentVisibilityDataItem = {
  path: string
  name: string
  desc: string
}

export type SegmentVisibilityData = Record<
  SegmentVisibility,
  SegmentVisibilityDataItem
>

export type SegmentPermission = 'update' | 'update_visibility' | 'destroy'

export type Segment = {
  id: number
  name: string
  recommended: boolean
  class?: string
  visibility: SegmentVisibility
  permissions: Record<SegmentPermission, boolean>
  partner?: string
  insight_triggers_count: number
}

export type EditSegmentModalType = 'save_as' | 'save' | 'edit'

export type CompaniesListCell = {
  href: string
  uuid: string
  formatted_value: string
  filter_error?: string
}

export type InsightsFilter = {
  uuid: string
  type: string
}

export type InsightsColumn = {
  filter: InsightsFilter
  name: string
}

export type InsightsColumnAction = {
  titleKey: typeof insightColumnActionTitleKeys[keyof typeof insightColumnActionTitleKeys]
  click: (param?: number) => void
}

export const insightColumnActionTitleKeys = {
  MOVE_LEFT: 'move_left',
  MOVE_RIGHT: 'move_right',
  SORT_ASC: 'sort_ascending',
  SORT_DESC: 'sort_descending',
  EDIT: 'edit',
  REMOVE: 'remove',
} as const

export type UpdateSortPayload = {
  sortColumn: string
  sortType: string
}
export type UpdateFilterPositionPayload = {
  uuid: string
  position: number
}

export type Job = {
  insight_action_run_id: number
  running: boolean
  finished: boolean
  processed_count: number
  total_count: number
  action_name?: string
  payload: { [key: string]: unknown }
}

export type Company = {
  id: string
  name: string
}

export type FirmWorkflow = {
  id: string
  name: string
}
